import React, { useContext } from 'react';
import AtomicButton from '../../atomic/button/Button';
import { useNavigate } from 'react-router-dom';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import BIG_PLANT from '../../utils/assets/png/pricing-plant-big.png.webp';
import MEDIUM_PLANT from '../../utils/assets/png/pricing-plant-medium-1.png';
import SMALL_PLANT from '../../utils/assets/png/pricing-plant-small.png';
import { PlanFeatureList } from './PlanFeatureList';
import './priceplan.scss';

const PLAN_CARDS = [
  {
    plan: 'basic',
    title: 'Basic',
    subtitle: 'Restaurant Delivery',
    plant: SMALL_PLANT,
    cardClass: 'ppc-card--basic',
    buttonStyle: {
      backgroundColor: '#E9E9E9',
      color: '#3F3F6E',
      width: '100%',
      marginTop: 0,
      marginBottom: 0,
    },
    actionPlan: 'Basic',
  },
  {
    plan: 'enterprise',
    title: 'Enterprise',
    subtitle: 'Partner Delivery',
    subtitleClass: 'ppc-card__subtitle--enterprise',
    plant: BIG_PLANT,
    plantClass: 'ppc-card__img--tall',
    cardClass: 'ppc-card--enterprise',
    buttonStyle: {
      backgroundColor: '#3F3F6E',
      width: '100%',
      marginTop: 0,
      marginBottom: 0,
    },
    actionPlan: 'Enterprise',
    isEnterprise: true,
  },
];

const PricePlanCard = ({ buttonLabel = 'Get started', onPlanSelect, rowClassName = '' }) => {
  const { setShowSignup, setSelectedPricePLan } = useContext(GlobalStateDataContext);
  const navigate = useNavigate();

  const handleDefaultPlanSelect = (plan) => {
    setSelectedPricePLan(plan);
    setShowSignup(true);
    navigate('/signup');
  };

  const handlePlanAction = onPlanSelect ?? handleDefaultPlanSelect;

  const renderCard = (card) => (
    <div key={card.plan} className={`ppc-card ${card.cardClass}`}>
      <div className='ppc-card__image-wrap'>
        <img alt='' src={card.plant} className={`ppc-card__img ${card.plantClass ?? ''}`.trim()} />
      </div>
      <div className='ppc-card__body'>
        <div className='ppc-card__title'>{card.title}</div>
        <div className={`ppc-card__subtitle ${card.subtitleClass ?? ''}`.trim()}>
          {card.subtitle}
        </div>
        <PlanFeatureList plan={card.plan} />
      </div>
      <div className='ppc-card__terms'>Terms & Conditions Apply</div>
      <div className='ppc-card__footer'>
        <AtomicButton
          label={buttonLabel}
          handleSubmit={() => handlePlanAction(card.actionPlan)}
          style={card.buttonStyle}
          loading={false}
          disabled={false}
        />
      </div>
    </div>
  );

  const basicPlusCards = PLAN_CARDS.filter((card) => !card.isEnterprise);
  const enterpriseCard = PLAN_CARDS.find((card) => card.isEnterprise);

  return (
    <div className={`ppc-row ${rowClassName}`.trim()}>
      <div className='ppc-pair'>{basicPlusCards.map(renderCard)}</div>

      <div className='ppc-enterprise-wrap'>{enterpriseCard && renderCard(enterpriseCard)}</div>
    </div>
  );
};

export default PricePlanCard;
